import Component from 'vue-class-component'
import ContainerVue from './Container'
import { IContainerData } from '../../store/editor/components/state'
import { EAST, WEST } from './Droppable'
import InteractableComponent from './InteractableComponent'
import { Actions } from '../../store/editor/components/helpers'

@Component
export default class RowsVue extends ContainerVue<IContainerData> {
  private interactable: InteractableComponent

  mounted() {
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.droppable({
      directions: [WEST, EAST]
    })
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
  }

  destroyed() {
    this.interactable.destroy()
  }
}
